export const TIMESHEET_ITEM_TYPES: any[] = [
  {
    id: 0,
    name: "Barge",
  },
  {
    id: 1,
    name: "Coaster",
  },
  {
    id: 2,
    name: "Container",
  },
  {
    id: 3,
    name: "Item",
  },
  {
    id: 4,
    name: "Lot",
  },
  {
    id: 5,
    name: "Shoretank",
  },
  {
    id: 6,
    name: "Tank",
  },
  {
    id: 7,
    name: "Wagon",
  },
  {
    id: 8,
    name: "Vehicle",
  },
  {
    id: 9,
    name: "Vessel",
  },
  {
    id: 10,
    name: "Truck",
  },
];
